import EditScopeContainer from "./EditScopeContainer";
export default EditScopeContainer;
